//Magyarország megyéi
import * as hu_counties_2014 from "highcharts-ksh/dist/esm/maps/hu/counties/2014";
import * as hu_counties_2020 from "highcharts-ksh/dist/esm/maps/hu/counties/2020";
import * as hu_counties_2023 from "highcharts-ksh/dist/esm/maps/hu/counties/2023";
//Magyarország járásai.
import * as hu_districts_2014 from "highcharts-ksh/dist/esm/maps/hu/districts/2014";
import * as hu_districts_2015 from "highcharts-ksh/dist/esm/maps/hu/districts/2015";
import * as hu_districts_bpegyben_2015 from "highcharts-ksh/dist/esm/maps/hu/districts/2015_bpegyben";
import * as hu_districts_bp_2015 from "highcharts-ksh/dist/esm/maps/hu/districts/2015_bpkiemelve";
import * as hu_districts_2019 from "highcharts-ksh/dist/esm/maps/hu/districts/2019";
import * as hu_districts_bpegyben_2019 from "highcharts-ksh/dist/esm/maps/hu/districts/2019_bpegyben";
import * as hu_districts_bp_2019 from "highcharts-ksh/dist/esm/maps/hu/districts/2019_bpkiemelve";
//Magyarország régiói.
import * as hu_regions_2014 from "highcharts-ksh/dist/esm/maps/hu/regions/2014";
import * as hu_regions_2018 from "highcharts-ksh/dist/esm/maps/hu/regions/2018";
//Magyarország települései.
import * as hu_settlements_2015 from "highcharts-ksh/dist/esm/maps/hu/settlements/2015";
import * as hu_settlements_2015_bpker from "highcharts-ksh/dist/esm/maps/hu/settlements/2015_bpker";
import * as hu_settlements_2015_cdv from "highcharts-ksh/dist/esm/maps/hu/settlements/2015_cdv";
import * as hu_settlements_2015_bpker_cdv from "highcharts-ksh/dist/esm/maps/hu/settlements/2015_bpker_cdv";
//Magyarország túrisztikai régiói
import * as hu_tourismregions from "highcharts-ksh/dist/esm/maps/hu/tourismregions"
// Budapesti kerületes térkép.
import * as hu_budapest_1994_districts from "highcharts-ksh/dist/esm/maps/hu/budapest/1994_districts";
import * as hu_budapest_1994_settlements from "highcharts-ksh/dist/esm/maps/hu/budapest/1994_settlements";
import * as hu_budapest_1994_settlements_cdv from "highcharts-ksh/dist/esm/maps/hu/budapest/1994_settlements_cdv";

//Minden európai ország.
import * as eu_all from "highcharts-ksh/dist/esm/maps/eu/all";
//Az európán kívül eső országok.
import * as eu_noneu from "highcharts-ksh/dist/esm/maps/eu/noneu";
import * as eu_noneu_noborder from "highcharts-ksh/dist/esm/maps/eu/noneu/noborder";
//EU NUTS
import * as eu_nuts0_2016 from "highcharts-ksh/dist/esm/maps/eu/nuts0/2016";
import * as eu_nuts1_2016 from "highcharts-ksh/dist/esm/maps/eu/nuts1/2016";
import * as eu_nuts2_2016 from "highcharts-ksh/dist/esm/maps/eu/nuts2/2016";
import * as eu_nuts3_2016 from "highcharts-ksh/dist/esm/maps/eu/nuts3/2016";
//Az EU-28 országai
import * as eu_eu28 from "highcharts-ksh/dist/esm/maps/eu/eu28";
import * as eu_eu28_other_noborder from "highcharts-ksh/dist/esm/maps/eu/eu28/other/noborder";
import * as eu_eu28_other from "highcharts-ksh/dist/esm/maps/eu/eu28/other";
//Az EU-27-2020 országai
import * as eu_eu27_2020 from "highcharts-ksh/dist/esm/maps/eu/eu27_2020";
import * as eu_eu27_2020_other_noborder from "highcharts-ksh/dist/esm/maps/eu/eu27_2020/other/noborder";
import * as eu_eu27_2020_other from "highcharts-ksh/dist/esm/maps/eu/eu27_2020/other";


import * as world_2020 from "highcharts-ksh/dist/esm/maps/world-2020";

const mapList = {
    'hu_counties_2014': hu_counties_2014,
    'hu_counties_2020': hu_counties_2020,
    'hu_counties_2023': hu_counties_2023,
    'hu_districts_2014': hu_districts_2014,
    'hu_districts_2015': hu_districts_2015,
    'hu_districts_bpegyben_2015': hu_districts_bpegyben_2015,
    'hu_districts_bp_2015': hu_districts_bp_2015,
    'hu_districts_2019': hu_districts_2019,
    'hu_districts_bpegyben_2019': hu_districts_bpegyben_2019,
    'hu_districts_bp_2019': hu_districts_bp_2019,
    'hu_regions_2014': hu_regions_2014,
    'hu_regions_2018': hu_regions_2018,
    'hu_settlements_2015': hu_settlements_2015,
    'hu_settlements_2015_bpker': hu_settlements_2015_bpker,
    'hu_settlements_2015_cdv': hu_settlements_2015_cdv,
    'hu_settlements_2015_bpker_cdv': hu_settlements_2015_bpker_cdv,
    'hu_tourismregions': hu_tourismregions,
    'hu_budapest_1994_districts': hu_budapest_1994_districts,
    'hu_budapest_1994_settlements': hu_budapest_1994_settlements,
    'hu_budapest_1994_settlements_cdv': hu_budapest_1994_settlements_cdv,
    
    'eu_all': eu_all,
    'eu_noneu': eu_noneu,
    'eu_noneu_noborder': eu_noneu_noborder,
    'eu_nuts0_2016': eu_nuts0_2016,
    'eu_nuts1_2016': eu_nuts1_2016,
    'eu_nuts2_2016': eu_nuts2_2016,
    'eu_nuts3_2016': eu_nuts3_2016,
    'eu_eu28': eu_eu28,
    'eu_eu28_other_noborder': eu_eu28_other_noborder,
    'eu_eu28_other': eu_eu28_other,
    'eu_eu27_2020': eu_eu27_2020,
    'eu_eu27_2020_other_noborder': eu_eu27_2020_other_noborder,
    'eu_eu27_2020_other': eu_eu27_2020_other,

    'world_2020': world_2020
    }

const getMap = (map, lang) => { const o = mapList[map]; return o[lang] || o.default };

function callMap(Highcharts, maps, lang) {
    if (maps.length>0){
        Highcharts.maps = Object.assign(Highcharts.maps,
            maps.reduce((obj, key) => {
                obj[key] = getMap(key, lang);
                return obj;
            }, {})
        );
    }
}

export default callMap;
